module.exports = "/images/icon_72_leftchev.png?2a071edbff40bef20e0ff68b4af8ceba";